// extracted by mini-css-extract-plugin
export default {"actionsIcon":"actions-dropdown_actionsIcon__g534S","dropdownMenu":"actions-dropdown_dropdownMenu__nFhAH","item":"actions-dropdown_item__gQMbO"};